exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.conecta-add__base .ag-pinned-left-cols-container,\n.conecta-add__base .ag-header .ag-pinned-left-header,\n.conecta-add__base .ag-body-horizontal-scroll .ag-horizontal-left-spacer {\n  display: none;\n}\n.conecta-add__base .estilo-grilla,\n#gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n", ""]);

// exports
